export function sortBySelectedIdGlobal<T extends { idGlobal?: string | number }>(
    data: T[],
    selected?: T[]
): T[] {
    if (!selected || selected.length === 0) {
        return data;
    }

    const selectedIdSet = new Set(
        selected
            .map(item => item.idGlobal)
            .filter(Boolean)
    );

    if (selectedIdSet.size === 0) {
        return data;
    }

    const selectedItems: T[] = [];
    const restItems: T[] = [];

    for (const item of data) {
        if (item.idGlobal && selectedIdSet.has(item.idGlobal)) {
            selectedItems.push(item);
        } else {
            restItems.push(item);
        }
    }

    return [...selectedItems, ...restItems];
}